module.exports = __webpack_public_path__ + "static/media/dr-odua-dashen-opticians.21a0ad24.jpg";